import classNames from 'classnames';

import { Button } from '../button/button.component';
import { ImageEmbedded } from '../image/image-embedded';
import { Link } from '../link/link';
import { TitleV2 } from '../titlev2/titlev2.component';
import TypographyV2, { FontWeight } from '../typographyv2/typographyv2';

import { ContentChipProps, ContentChipIsEmpty } from './content-chip.config';

const ContentChip = ({
  additionalClasses,
  appliedCssClassNames,
  cqPath,
  cta,
  headline,
  image,
  isInEditor,
  propertiesId,
  propertiesLabel,
  propertiesRole,
  tagColor,
  tagText,
}: ContentChipProps) => {
  const hasBackground = appliedCssClassNames
    ?.split(' ')
    .some((appliedCssClassName) => appliedCssClassName.includes('bg'));
  const hasMidBlueBackground = appliedCssClassNames?.includes('snowflake-content-chip-mid-blue-100-bg');
  const hasLightGrayBackground = appliedCssClassNames?.includes('snowflake-content-chip-gray-10-bg');
  const hasWhiteText = appliedCssClassNames?.includes('snowflake-content-chip-white-text') && !hasBackground;
  const { heapButtonClasses, ...ctaProps } = cta || {};

  return !ContentChipIsEmpty({ cqPath, cta, headline, isInEditor }) ? (
    <Link
      link={cta.buttonLink}
      id={propertiesId}
      ariaLabel={propertiesLabel}
      role={propertiesRole}
      wistiaVideo={cta.wistiaVideo}
      className={classNames('snowflake-content-chip', additionalClasses, {
        'snowflake-content-chip-with-background': hasBackground,
        [`${heapButtonClasses?.join(' ')}`]: heapButtonClasses?.length,
      })}
      dataTestid="snowflake-content-chip"
    >
      {image && <ImageEmbedded {...image} baseCssClass="snowflake-content-chip-image" />}
      <div
        className={classNames('snowflake-content-chip-content', {
          'snowflake-content-chip-content-without-tag': !tagText,
        })}
      >
        {tagText && (
          <div
            data-testid="snowflake-content-chip-tag"
            className={classNames('snowflake-content-chip-tag', {
              'snowflake-content-chip-tag-white-background': hasLightGrayBackground,
              'snowflake-content-chip-tag-dark-background': hasMidBlueBackground || hasWhiteText,
            })}
          >
            <div className="snowflake-content-chip-tag-indicator" style={{ backgroundColor: tagColor }} />
            <TypographyV2 fontWeight={FontWeight.MEDIUM} variant="" variantClassName="body-4">
              {tagText}
            </TypographyV2>
          </div>
        )}
        <div
          className={classNames({
            'black-blue-text-color': !hasMidBlueBackground,
            'white-black-text-color': hasMidBlueBackground || hasWhiteText,
          })}
        >
          <TitleV2 {...headline} />
        </div>
        <div
          className={classNames('snowflake-content-chip-button snowflake-button-blue snowflake-button-link', {
            'snowflake-button-blue': !hasMidBlueBackground,
            'snowflake-button-white': hasMidBlueBackground || hasWhiteText,
          })}
        >
          <Button {...ctaProps} appliedCssClassNames="snowflake-button-link" disableAnchor tabIndex={-1} />
        </div>
      </div>
    </Link>
  ) : null;
};

export default ContentChip;
